import { ActionFactoryParams } from '../../../../utilsDeprecated/ControlledComponent/ControlledComponent.types';
import { CalendarStateDeprecated } from '../../controller';
import { CalendarContext } from '../../../../utilsDeprecated/context/contextFactory';
import { RefetchPlatformData } from '../refetchPlatformData/refetchPlatformData';
import { FilterTypes } from '../../ViewModelDeprecated/filterViewModel/filterViewModel';
import { TriggeredByOptions } from '../../../../types/types';

export type OnFilterChanged = (
  filter: Partial<Record<FilterTypes, string[]>> | undefined,
) => Promise<void>;

export function createOnFilterChanged(
  {
    getControllerState,
    context: { biLogger, experiments },
  }: ActionFactoryParams<CalendarStateDeprecated, CalendarContext>,
  refetchPlatformData: RefetchPlatformData,
): OnFilterChanged {
  return (filter: Parameters<OnFilterChanged>[0]) => {
    const [state, setState] = getControllerState();

    setState({
      filterOptions: filter
        ? {
            ...state.filterOptions,
            ...filter,
          }
        : {
            [FilterTypes.SERVICE]: [],
            [FilterTypes.LOCATION]: [],
            [FilterTypes.STAFF_MEMBER]: [],
          },
      selectedVariantsOptions: [],
    });

    return refetchPlatformData(TriggeredByOptions.FILTER_CHANGED);
  };
}
